export default "__VITE_ASSET__BmMrbtAa__"